import React from 'react'
import IntlMessages from '@vacationtracker/shared/components/utils/IntlMessages'
import { ANDROID_MOBILE_APP_URL, IOS_MOBILE_APP_URL } from '../../constants'

const MobileBanner = (): React.ReactElement => {
  return (
    <div className="mobile-banner">
      <IntlMessages id="app.mobileBanner" />
      <a className="ios-banner" href={IOS_MOBILE_APP_URL} target="_blank" rel="noopener noreferrer"></a>
      <a className="android-banner" href={ANDROID_MOBILE_APP_URL} target="_blank" rel="noopener noreferrer"></a>
    </div>
  )
}

export default MobileBanner
